
// TODO: Success and fail actions for API calls

const actions = {
  FETCH_QUESTIONNAIRES: 'FETCH_QUESTIONNAIRES',
  CREATE_QUESTIONNAIRE: 'CREATE_QUESTIONNAIRE',
  EDIT_QUESTIONNAIRE: 'EDIT_QUESTIONNAIRE',
  DELETE_QUESTIONNAIRE: 'DELETE_QUESTIONNAIRE',
  FRONTEND_VALIDATION: 'FRONTEND_VALIDATION',
  CREATE_QUESTIONNAIRE_SUCCESS: 'CREATE_QUESTIONNAIRE_SUCCESS',
  FETCH_QUESTIONNAIRES_SUCCESS: 'FETCH_QUESTIONNAIRES_SUCCESS',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  CREATE_QUESTION: 'CREATE_QUESTION',
  DELETE_QUESTION: 'DELETE_QUESTION',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  API_CALL_FAILURE: 'API_CALL_FAILURE',
  FETCH_KARIE_USERS_SUCCESS: 'FETCH_KARIE_USERS_SUCCESS',
  FETCH_KARIE_USERS: 'FETCH_KARIE_USERS',
  ASSIGN_KARIE_USERS: 'ASSIGN_KARIE_USERS',
  ASSIGN_KARIE_USERS_SUCCESS: 'ASSIGN_KARIE_USERS_SUCCESS',
  ASSIGN_KARIE_USERS_ERROR: 'ASSIGN_KARIE_USERS_ERROR',
  fetchQuestionnaires: (questionnaires) => ({
    type: actions.FETCH_QUESTIONNAIRES
  }),
  createQuestionnaire: (questionnaire, history) => ({
    type: actions.CREATE_QUESTIONNAIRE,
    questionnaire: questionnaire,
    history: history
  }),
  editQuestionnaire: (questionnaireId, questionnaire, history) => ({
    type: actions.EDIT_QUESTIONNAIRE,
    questionnaireId: questionnaireId,
    questionnaire: questionnaire,
    history: history
  }),
  deleteQuestionnaire: (questionnaireId, resolve, reject) => ({
    type: actions.DELETE_QUESTIONNAIRE,
    questionnaireId: questionnaireId,
    resolve: resolve,
    reject: reject
  }),
  frontendValidation: (errors) => ({
    type: actions.FRONTEND_VALIDATION,
    errors: errors
  }),
  createQuestionnaireSuccess: (questionnaire) => ({
    type: actions.CREATE_QUESTIONNAIRE_SUCCESS,
    questionnaire: questionnaire
  }),
  fetchQuestionnairesSuccess: (questionnaires) => ({
    type: actions.FETCH_QUESTIONNAIRES_SUCCESS,
    questionnaires: questionnaires
  }),
  createQuestionRequest: (question, questionnaireId, history) => ({
    type: actions.CREATE_QUESTION,
    question: question,
    questionnaireId: questionnaireId,
    history: history
  }),
  fetchQuestions: (questionnaireId) => ({
    type: actions.FETCH_QUESTIONS,
    questionnaireId: questionnaireId
  }),
  fetchQuestionsSuccess: (questions) => ({
    type: actions.FETCH_QUESTIONS_SUCCESS,
    questions: questions
  }),
  fetchKarieUsers: (questionnaireId) => ({
    type: actions.FETCH_KARIE_USERS,
    questionnaireId,
  }),
  fetchKarieUsersSuccess: (karieUsers) => ({
    type: actions.FETCH_KARIE_USERS_SUCCESS,
    karieUsers,
  }),
  assignKarieUsers: (questionnaireId, assignIds, unassignIds) => ({
    type: actions.ASSIGN_KARIE_USERS,
    questionnaireId,
    assignIds,
    unassignIds,
  }),
  assignKarieUsersSuccess: (assignments, karieUsers) => ({
    type: actions.ASSIGN_KARIE_USERS_SUCCESS,
    karieUsers,
    assignments
  }),
  deleteQuestion: (questionnaireId, questionId, resolve, reject) => ({
    type: actions.DELETE_QUESTION,
    questionnaireId: questionnaireId,
    questionId: questionId,
    resolve: resolve,
    reject: reject
  }),
};
export default actions;
